import { createStore } from "vuex";
import createPersistedState from "vuex-plugin-persistedstate";

import authModule from "./auth/index.js";
import surveyModule from "./Application/Embedded/Survey/index.js";
import geosatModule from "./Application/Embedded/GeoSat/index.js";
import notificationModule from "./Notification/index.js";

export default createStore({
  state: {
    showMaintenanceModal: false,
    showDeviceIncompatibilityModal: false,
    deviceIncompatibilityAppType: null,
  },
  getters: {},
  mutations: {
    SHOW_MAINTENANCE_MODAL(state, value) {
      state.showMaintenanceModal = value;
    },
    SHOW_DEVICE_INCOMPATIBILITY_MODAL(state, value) {
      state.showDeviceIncompatibilityModal = value;
    },
    SET_DEVICE_INCOMPATIBILITY_APP_TYPE(state, value) {
      state.deviceIncompatibilityAppType = value;
    },
  },
  actions: {},
  modules: {
    auth: authModule,
    survey: surveyModule,
    GeoSatStore: geosatModule,
    notification: notificationModule,
  },
  plugins: [createPersistedState()],
});
